import { Navigate } from "react-router-dom";
import { useStores } from "../../../stores/store";
import { Container } from "../container";

const UserRoute = ({ Component }) => {
	const { auth } = useStores();

    return auth.isUser() ? 
        <Component />
    :
        <Navigate to="/page401" />;
};
export default UserRoute;